/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserFindByLogin } from '../../models/user-find-by-login';
import { UserSummary } from '../../models/user-summary';

export interface FindUserByLogin$Params {
  
    /**
     * Find if an user exist for this login
     */
    body: UserFindByLogin
}

export function findUserByLogin(http: HttpClient, rootUrl: string, params: FindUserByLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<UserSummary>> {
  const rb = new RequestBuilder(rootUrl, findUserByLogin.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserSummary>;
    })
  );
}

findUserByLogin.PATH = '/users/findByLogin';
